import {Store} from "@reduxjs/toolkit"
import State from "../../models/State"
import {SettingsSdkKeys} from "../../models/settings"
import {FeatureSwitch} from "../../models/FeatureSwitch"
import {FeatureSettings} from "../../models/FeatureFlags"

export interface FeaturesDuckState {
    overrideSeo?: {
        metadata: boolean
        headings: boolean
    }
    enableSearchBanners: boolean
    enableTooltips: boolean
    enableNewProductSummary: boolean
}

export const SET_FEATURE_SWITCH = "SET_FEATURES"

interface Action {
    type: typeof SET_FEATURE_SWITCH
    featureSwitchData: FeatureSwitchInterface
}

export const setFeatureSwitch = (featureSwitchData: FeatureSwitchInterface): Action => {
    return {
        type: SET_FEATURE_SWITCH,
        featureSwitchData,
    }
}

export interface FeatureSwitchInterface {
    overrideSeo?: {
        metadata: boolean
        headings: boolean
    }
    enableSearchBanners: boolean
    enableTooltips: boolean
    enableNewProductSummary: boolean
}

type FeatureSwitchConf = {
    [SettingsSdkKeys.FeatureSwitch]: any
}

export const updateFeatureSwitch = (
    store: Store,
    configuration: FeatureSwitchConf,
    featureSettings: FeatureSettings,
) => {
    const featureSwitchData = configuration[SettingsSdkKeys.FeatureSwitch] as FeatureSwitch

    store.dispatch({
        type: SET_FEATURE_SWITCH,
        featureSwitchData: {
            ...featureSwitchData,
            enableNewProductSummary: featureSwitchData?.enableNewProductSummary,
        },
    })
}

export const selectOverrideMetadata = (state: State) => {
    const {overrideSeo} = state.features
    return overrideSeo?.metadata
}

const initialState: FeaturesDuckState = {
    overrideSeo: {
        metadata: false,
        headings: false,
    },
    enableSearchBanners: false,
    enableTooltips: false,
    enableNewProductSummary: false,
}

const reducer = (state: FeaturesDuckState = initialState, action: Action): FeaturesDuckState => {
    const {type, featureSwitchData} = action
    switch (type) {
        case SET_FEATURE_SWITCH:
            return {
                ...state,
                ...featureSwitchData,
            }
        default:
            return state
    }
}

export default reducer
